// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__35EIN","rootCenter":"LoadMoreObserver_rootCenter__J9kZ2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2XzdI"};